<template>
  <v-app>
    <v-container>
      <v-row>
        <!-- Drawer for categories -->
        <v-navigation-drawer
          app
          permanent
          color="white"
        >
          <v-text-field
            v-model="search"
            label="جستجوی محصول"
            outlined
            dense
          />
          <v-btn
            block
            color="primary"
            outlined
            class="mb-2"
          >
            تعریف محصول
          </v-btn>
          <v-list dense>
            <v-list-item-group>
              <v-list-item
                v-for="category in categories"
                :key="category"
                :active-class="'list-item-active'"
                :class="{'list-item': true, 'list-item-active': selectedCategory === category}"
                @click="selectCategory(category)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ category }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>

        <!-- Product List -->
        <v-col
          cols="4"
          class="product-list"
        >
          <v-row>
            <v-col
              v-for="product in filteredProducts"
              :key="product.id"
              cols="12"
            >
              <v-card class="mb-2 product-card">
                <v-card-title>
                  <v-avatar left>
                    <img
                      :src="product.image"
                      alt="product"
                    >
                  </v-avatar>
                  <v-spacer />
                  {{ product.name }}
                </v-card-title>
                <v-card-subtitle>{{ product.price }} تومان</v-card-subtitle>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    @click="addToCart(product)"
                  >
                    افزودن
                  </v-btn>
                  <v-btn icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!-- Shopping Cart -->
        <v-col cols="8">
          <v-data-table
            :headers="cartHeaders"
            :items="cart"
            item-value="id"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                @click="removeFromCart(item.product.id)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-divider class="my-3" />
          <v-row>
            <v-col cols="6">
              <v-btn
                block
                color="success"
                @click="checkout"
              >
                پرداخت
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                block
                color="error"
                @click="clearCart"
              >
                لغو
              </v-btn>
            </v-col>
          </v-row>
          <v-card class="mt-3">
            <v-card-text>
              جمع مبلغ بدون مالیات و تخفیف: {{ total }} تومان
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        categories: ['همه محصولات', 'شکلات و تنقلات', 'بهداشتی و آرایشی', 'خشکبار و آجیل', 'لوازم التحریر', 'لبنیات'],
        selectedCategory: 'همه محصولات',
        products: [
          { id: 1, name: 'بیسکویت', price: 10000, image: 'link_to_image' },
          { id: 2, name: 'شکلات', price: 20000, image: 'link_to_image' },
          { id: 3, name: 'نوشابه', price: 30000, image: 'link_to_image' },
          { id: 4, name: 'چیپس', price: 15000, image: 'link_to_image' },
          { id: 5, name: 'پفک', price: 12000, image: 'link_to_image' },
          { id: 6, name: 'آبمیوه', price: 8000, image: 'link_to_image' },
        ],
        cart: [],
        cartHeaders: [
          { text: 'نام محصول', align: 'start', value: 'product.name' },
          { text: 'قیمت', value: 'product.price' },
          { text: 'تعداد', value: 'quantity' },
          { text: 'اقدامات', value: 'actions', sortable: false },
        ],
      }
    },
    computed: {
      filteredProducts () {
        if (this.selectedCategory === 'همه محصولات') {
          return this.products.filter(product => product.name.includes(this.search))
        }
        // فیلتر بر اساس دسته‌بندی انتخابی
        return this.products.filter(product => product.category === this.selectedCategory && product.name.includes(this.search))
      },
      total () {
        return this.cart.reduce((sum, item) => sum + item.product.price * item.quantity, 0)
      },
    },
    methods: {
      selectCategory (category) {
        this.selectedCategory = category
      },
      addToCart (product) {
        const item = this.cart.find(i => i.product.id === product.id)
        if (item) {
          item.quantity++
        } else {
          this.cart.push({ product, quantity: 1 })
        }
      },
      removeFromCart (productId) {
        const index = this.cart.findIndex(item => item.product.id === productId)
        if (index !== -1) {
          this.cart.splice(index, 1)
        }
      },
      clearCart () {
        this.cart = []
      },
      checkout () {
        alert(`قیمت نهایی: ${this.total} تومان`)
        this.cart = []
      },
    },
  }
</script>

<style>
.sidebar {
  background-color: #f9f9f9;
  padding: 10px;
}

.product-list {
  background-color: #fff;
  padding: 10px;
}

.product-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shopping-cart {
  background-color: #fff;
  padding: 10px;
}

.list-item-active {
  background-color: #e0e0e0;
}

.v-application--is-ltr .v-list-item {
  justify-content: flex-end;
}

.v-application--is-ltr .v-list-item__content {
  text-align: right;
}

.v-application--is-ltr .v-list-item__action {
  margin-left: 0;
  margin-right: 16px;
}

.v-btn {
  margin: 4px 0;
}
</style>
